var React = require('react');

function HeartCircle (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm0 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zM14.777 7.5c-.951 0-2.071.492-2.777 1.785-.706-1.293-1.826-1.785-2.777-1.785-1.584 0-3.223 1.323-3.223 3.537 0 3.181 5.473 7.198 5.706 7.367.088.064.19.096.294.096s.206-.032.294-.096c.233-.169 5.706-4.186 5.706-7.367 0-2.214-1.639-3.537-3.223-3.537zm-2.777 9.876c-1.63-1.246-5-4.252-5-6.339 0-1.588 1.13-2.537 2.223-2.537 1.087 0 1.943.865 2.291 2.313.109.45.863.45.973 0 .347-1.448 1.203-2.313 2.29-2.313 1.093 0 2.223.949 2.223 2.537 0 2.084-3.37 5.092-5 6.339z"})));
}

HeartCircle.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = HeartCircle;

HeartCircle.default = HeartCircle;
